export default __webpack_public_path__ + "media/images/dashboard_icons/fonts-2f708726747f0c5ffac6b75b4ac78199.svg";